import React, { useState, useEffect } from "react";
import { getFirestore, collection, query, orderBy, onSnapshot, addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import "./GroupChatView.css";
import ChatMessageText from "./ChatMessageText";

const GroupChatView = ({ activeConversation, setActiveConversation }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [members, setMembers] = useState([]);
  const db = getFirestore();
  const auth = getAuth();

  // Fetch Group Info and Messages
  useEffect(() => {
    if (!activeConversation) return;

    // Fetch messages for the active group
    const messagesRef = collection(db, "conversations", activeConversation.id, "messages");
    const q = query(messagesRef, orderBy("timestamp", "asc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    });

    // Fetch members (for demo purposes, assuming members are part of the conversation document)
    const fetchMembers = async () => {
      const groupDoc = activeConversation.contact; // Assuming contact has group info
      setMembers(groupDoc.members || []); // Replace with actual group data structure
    };

    fetchMembers();

    return () => unsubscribe();
  }, [activeConversation, db]);

  // Handle Sending Messages
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      const { uid } = auth.currentUser;

      await addDoc(collection(db, "conversations", activeConversation.id, "messages"), {
        senderId: uid,
        text: newMessage,
        timestamp: serverTimestamp(),
      });

      setNewMessage("");
    }
  };

  return (
    <div className="group-chat-container">
      {/* Sidebar */}
      <div className="sidebar">
        <h3>All Chats</h3>
        <ul>
          <li className="chat-item active" onClick={() => setActiveConversation(null)}>
            Design chat
          </li>
        </ul>
      </div>

      {/* Main Chat Area */}
      <div className="chat-main">
        <div className="chat-header">
          <h2>{activeConversation?.contact?.name || "Group Chat"}</h2>
          <p>{members.length} members</p>
        </div>
        <div className="chat-messages">
          {messages.map((message) => (
            <div key={message.id} className={`message ${message.senderId === auth.currentUser.uid ? "sent" : "received"}`}>
              <ChatMessageText text={message.text} />
              <span>{new Date(message.timestamp?.toDate()).toLocaleTimeString()}</span>
            </div>
          ))}
        </div>
        <form onSubmit={handleSendMessage} className="chat-input">
          <input
            type="text"
            placeholder="Your message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
          />
          <button type="submit">Send</button>
        </form>
      </div>

      {/* Group Info Sidebar */}
      <div className="group-info">
        <h3>Group Info</h3>
        <div>
          <h4>Members</h4>
          <ul>
            {members.map((member, index) => (
              <li key={index}>{member.name || member}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GroupChatView;
